import React from "react";

export default function PersonalInfo({ data, error }) {
  if (error) {
    return (
      <div>
        <div style={{ color: "black" }}>NO BRO</div>
      </div>
    );
  }
  return (
    <section id="personalInfo">
      <div>{data.name} {data.surname}</div>
      <div>{data.organization}</div>
      <div>{data.title}</div>
      <div>{data.note}</div>
    </section>
  );
}
